<section class="section__header">
    <div class="section__title-row">
      <h2 class="section__title">{{ title() | translate }}</h2>
      <div class="badge badge--count">{{ coursesCount() }}</div>
    </div>
    <p class="section__subtitle">{{ subtitle() | translate }}</p>
    <div class="filter-chips">
      <button
        *ngFor="let chip of filterChips()"
        class="filter-chip"
        [class.filter-chip--active]="chip.isActive"
        (click)="onChipClick(chip)"
      >
        {{ chip.label | translate }}
      </button>
    </div>
  </section>